export enum PersonalDetailsFormField {
  Address = 'address',
  EmailAddress = 'emailAddress',
  FirstName = 'firstName',
  LastName = 'lastName',
  TelephoneNumber = 'telephoneNumber',
  TitleId = 'titleId',
}
